export default "__VITE_ASSET__D4$0_rjm__"